// Copyright (c) 2026. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted

/**
 * Centralized query key definitions for return order-related queries.
 * All return order query keys should be defined here to ensure consistency.
 */

/**
 * Base query key for all return order queries.
 * Invalidating this key will invalidate all return order-related queries.
 */
export const returnOrdersQueryKey = ['returnOrders'] as const;

/**
 * Creates a query key for a return order list with optional filters.
 *
 * @param filter - Optional filter parameters
 * @returns Query key array for the return order list query
 */
export function returnOrderListQueryKey(filter?: unknown) {
  return filter ? [...returnOrdersQueryKey, filter] : returnOrdersQueryKey;
}

/**
 * Creates a query key for a single return order detail by key.
 *
 * @param returnOrderKey - The unique key of the return order
 * @returns Query key array for the return order detail query
 */
export function returnOrderDetailQueryKey(returnOrderKey: string) {
  return [...returnOrdersQueryKey, returnOrderKey] as const;
}

/**
 * Creates a query key for return order files.
 *
 * @param returnOrderKey - The unique key of the return order
 * @returns Query key array for the return order files query
 */
export function returnOrderFilesQueryKey(returnOrderKey: string) {
  return [...returnOrdersQueryKey, returnOrderKey, 'files'] as const;
}

/**
 * Creates a query key for return order URL links.
 *
 * @param returnOrderKey - The unique key of the return order
 * @returns Query key array for the return order URL links query
 */
export function returnOrderURLLinksQueryKey(returnOrderKey: string) {
  return [...returnOrdersQueryKey, returnOrderKey, 'url-link'] as const;
}
